import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type GetQuizzesSortByOptions =
   | 'guideid'
   | 'category'
   | 'quiz_title'
   | 'guide_title'
   | 'quiz_last_released'
   | 'quizzes_submitted';

export type GetQuizzesSortByDirections = 'ASC' | 'DESC';

export type QuizInformation = {
   quizid: number;
   quiz_title: string;
   guideid: number;
   guide_title: string;
   docid: number;
   doc_title: string;
   doctype: string;
   guide_release_version: string;
   quizzes_submitted: number;
   category: string;
   quiz_last_released: number;
};

export type GetQuizzesResponse = {
   quizzes: QuizInformation[];
   hasMore: boolean;
};

export type GetQuizzesFilters = {
   guideid?: number;
};

export type GetQuizzesOptions = CommonRequestOptions & {
   limit?: number;
   query?: string;
   offset?: number;
   category?: string;
   filters?: GetQuizzesFilters;
   orderby?: GetQuizzesSortByOptions;
   direction?: GetQuizzesSortByDirections;
};

export async function getQuizzes({
   limit,
   query,
   offset,
   orderby,
   category,
   direction,
   ...common
}: GetQuizzesOptions = {}): Promise<GetQuizzesResponse> {
   return makeRequest('get', '/quizzes', {
      ...common,
      query: {
         limit,
         query,
         offset,
         orderby,
         category,
         direction,
      },
   });
}
